import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ShieldAlert, Loader2 } from "lucide-react";
import api from "@/lib/api";

/** Gates internal New Citizen tooling to the dev team (role=dev) and admins until public release. */
export default function DevGate({ children, toolName = "This tool" }) {
  const [me, setMe] = useState(undefined);

  useEffect(() => {
    api.get("/auth/me").then((r) => setMe(r.data)).catch(() => setMe(null));
  }, []);

  if (me === undefined) {
    return (
      <div className="flex-1 flex items-center justify-center py-32">
        <Loader2 className="w-6 h-6 text-nc-blue animate-spin" />
      </div>
    );
  }

  if (me && (me.role === "dev" || me.role === "admin")) return children;

  return (
    <div data-testid="dev-gate" className="flex-1 flex items-center justify-center px-4 py-24 relative overflow-hidden">
      <div className="absolute inset-0 grid-texture opacity-30" />
      <div className="relative max-w-md text-center border border-nc-orange/40 bg-[#0a0a0a] p-10">
        <ShieldAlert className="w-10 h-10 text-nc-orange mx-auto mb-5" strokeWidth={1.25} />
        <p className="font-mono text-[10px] tracking-[0.4em] text-nc-orange uppercase mb-3">Internal build // restricted</p>
        <h2 className="font-sans font-bold uppercase text-2xl text-zinc-50 mb-4">Dev team access only</h2>
        <p className="font-mono text-xs text-zinc-400 leading-relaxed mb-6">
          {toolName} is still in closed development for the New Citizen dev team. It opens to every citizen at the public modding launch — wishlist the game and watch the roadmap for the release window.
        </p>
        <div className="flex gap-3 justify-center flex-wrap">
          {!me && <Link to="/auth" className="font-mono text-[10px] tracking-[0.25em] uppercase bg-nc-blue text-white px-5 py-3 hover:bg-nc-blue/80 transition-colors">Dev sign-in</Link>}
          <Link to="/new-citizen" className="font-mono text-[10px] tracking-[0.25em] uppercase border border-white/20 text-zinc-300 hover:text-zinc-50 px-5 py-3 transition-colors">Back to New Citizen</Link>
        </div>
      </div>
    </div>
  );
}
